import React, { useEffect, useRef, useState } from "react";



const DcThresholdCustomTable = ({
  dcthreshold,
  handleDcThresholdCustomMonth,
  dcthresholdCustomMonthErrors,
  generateDefaultData,
  tooltipDataJSON
}) => {
  const [data, setData] = useState();
  const [errors, setErrors] = useState({});
const isDcThresholdCustomValueNonEmpty = () =>{
    const updatedErrors ={};
    let isCustomValueNonEmpty = false;
   dcthreshold?.customValues?.forEach((element, index)=> {
     if(element.billingPeriodPreset ==="" || element.billingPeriodPreset ===0){
       isCustomValueNonEmpty = true;
        updatedErrors[`${index}-${"billingPeriodPreset"}`] = "This field is required";
        
     }
     if( element.peakPreset ==="" || element.peakPreset === 0){
      isCustomValueNonEmpty = true;
       updatedErrors[`${index}-${"peakPreset"}`] = "This field is required";
        
     }
    
   });
   setErrors({ ...updatedErrors });
  }
    useEffect(() => {
    setErrors(dcthresholdCustomMonthErrors || {});
  },[dcthresholdCustomMonthErrors])
  useEffect(() => {
    isDcThresholdCustomValueNonEmpty();
  }, []);
  useEffect(() => {
    setData(dcthreshold.customValues || generateDefaultData());
    isDcThresholdCustomValueNonEmpty();
  }, [dcthreshold?.valueType]);

  const handleChange = (index, field, value) => {
    const updatedErrors = { ...errors };

    if (value === "" || value === 0) {
       const updated = [...data];
      updated[index][field] = value === "" ? "" : Number(value) || 0;
      setData(updated);
      handleDcThresholdCustomMonth(updated);
      updatedErrors[`${index}-${field}`] = "This field is required";
      setErrors(updatedErrors);
        } else if (
      /^(100(\.0{1,2})?|(\d{1,2}(\.\d{1,2})?)|(\d{1,2}\.))$/.test(value) && parseFloat(value) <= 100 &&
      dcthreshold?.valueType === "PERCENTAGE"
        ) {
      const updated = [...data];
      updated[index][field] = value === "" ? "" : value || 0;
      setData(updated);
      handleDcThresholdCustomMonth(updated);
       delete updatedErrors[`${index}-${field}`];
      setErrors(updatedErrors);
    } else if (
      Number(value) >= 0 &&
      Number(value) <= 999 &&
      dcthreshold?.valueType === "VALUE"
    ) {
      const updated = [...data];
      updated[index][field] = value === "" ? "" : value || 0;
      setData(updated);
      handleDcThresholdCustomMonth(updated);
      delete updatedErrors[`${index}-${field}`];
      setErrors(updatedErrors);
    } else {
     
    }
  };

  return (
    <div className="row mt-4">
      <div className="col-sm-8">
        <table className="table table-bordered text-center table-sm table-hover">
          <thead className="thead-light">
            <tr>
              <th>Month</th>
              <th><span>Demand Limit 1</span>
              <span><se-tooltip position="left">
                          <se-icon
                            option="raised"
                            slot="tooltip"
                            color="secondary"
                          >
                            information_circle
                          </se-icon>
                          <se-tooltip-content
                            style={{
                              textAlign: "left",
                              display: "block",
                              width: "295px",
                            }}
                          >
                            {tooltipDataJSON("DemandLimit1")}
                          </se-tooltip-content>
                        </se-tooltip></span>
                
              </th>
              <th><span>Demand Limit 2</span>

                  <span><se-tooltip position="left">
                          <se-icon
                            option="raised"
                            slot="tooltip"
                            color="secondary"
                          >
                            information_circle
                          </se-icon>
                          <se-tooltip-content
                            style={{
                              textAlign: "left",
                              display: "block",
                              width: "295px",
                            }}
                          >
                            {tooltipDataJSON("DemandLimit2")}
                          </se-tooltip-content>
                        </se-tooltip></span>
              </th>
            </tr>
          </thead>
          <tbody>
            {data?.map((item, index) => {
              const month = new Date(item.date).toLocaleString("default", {
                month: "long",
              });
              return (
                <tr key={index}>
                  <td>
                    <div className="pt-2">
                      <span>{month}</span>
                      <span className="se-mandatory">*</span>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex justify-content-center">
                      <input
                        type="text"
                        max="5"
                        className={`form-control form-control-sm w-50 ${
                          errors[`${index}-billingPeriodPreset`]
                            ? "is-invalid"
                            : ""
                        }`}
                        id={`billingPeriodPreset-${index}`}
                        value={item.billingPeriodPreset}
                        onChange={(e) =>
                          handleChange(
                            index,
                            "billingPeriodPreset",
                            e.target.value
                          )
                        }
                      />

                      <label
                        htmlFor={`billingPeriodPreset-${index}`}
                        className="col-sm-2 col-form-label text-right"
                      >
                        {dcthreshold?.valueType === "VALUE" ? "kW" : "%"}
                      </label>
                    </div>
                  </td>
                  <td>
                    <div className="d-flex justify-content-center">
                      {" "}
                      <input
                        type="text"
                        max="5"
                        id={`peakPreset-${index}`}
                        className={`form-control form-control-sm w-50 ${
                          errors[`${index}-peakPreset`] ? "is-invalid" : ""
                        }`}
                        value={item.peakPreset}
                        onChange={(e) =>
                          handleChange(index, "peakPreset", e.target.value)
                        }
                      />
                      <label
                        htmlFor={`peakPreset-${index}`}
                        className="col-form-label col-sm-2 text-right"
                      >
                        {dcthreshold?.valueType === "VALUE" ? "kW" : "%"}
                      </label>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DcThresholdCustomTable;
